import { useState, useRef, useEffect } from "react";

export default function ServiceDetailPerform() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-perform">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Performance</span>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-head">
                        <h4 className="heading">Excellence in Every Detail</h4>
                        <p>Our turnkey approach is built on precision, accountability, and consistency across all phases.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-list">
                        <p>Find out more</p>
                        <ul>
                            <li><span>01</span> Single-source accountability covering manufacturing, quality control and on-site delivery.</li>
                            <li><span>02</span> Coordinated MEP integration and trade scheduling to reduce rework.</li>
                            <li><span>03</span> Guaranteed finish standards with sample approvals and QA checkpoints.</li>
                            <li><span>04</span> Timely deliveries and phased installation plans to match project milestones.</li>
                            <li><span>05</span> Aftercare, warranty support and maintenance guidance post-handover.</li>
                            <li><span>06</span> Sustainable sourcing options and material traceability on request.</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
